import { ErrorBoundary } from "@shared/ui"
import { useAnalytics } from "@sustainability/analytics-frontend"

interface ErrorBoundaryProviderProps {
	children: React.ReactNode
}

export const ErrorBoundaryProvider: React.FC<ErrorBoundaryProviderProps> = ({
	children,
}) => {
	const { trackError } = useAnalytics()

	return <ErrorBoundary onError={trackError}>{children}</ErrorBoundary>
}
